import { Flex } from "antd"

import InputComponent from "../../../../../Components/Input"
import Icon from "../../../../../Icon"
import { descriptorStatuses, descriptorStatusTextMap } from "../../../utils/Enrollment.util"
import EnrollmentTabs from "../EnrollmentTabs/EnrollmentTabs"
import MultipleSelect from "../MultipleSelect/MultipleSelect"

import "./DescriptorListFilters.less"

const options = descriptorStatuses.map((status) => ({
  value: status,
  label: descriptorStatusTextMap[status]
}))

const DescriptorListFilters = ({
  filters,
  onFiltersChange,
                                 statusOptions = [],
                                 statusOptionsLoading = false,
  viewMode,
  onViewModeChange,
  showViewToggle = true,
  isCodesDisabled = false
}) => {
  const handleFilterChange = (newFilters) => {
    onFiltersChange?.({ ...filters, ...newFilters })
  }

  const handleStatusChange = (newStatuses) => {
    handleFilterChange({ statuses: newStatuses })
  }

  const handleSearchChange = (e) => {
    handleFilterChange({ search: e.target.value })
  }

  return (
    <Flex gap={8} className="descriptor-list-filters">
      <InputComponent
        placeholder="Search descriptors..."
        type="search"
        size="middle"
        prefix={<Icon type="search" />}
        className="descriptor-search-input"
        value={filters.search}
        onChange={handleSearchChange}
      />
      <MultipleSelect
        options={options}
        values={filters.statuses}
        onChange={handleStatusChange}
        allBtnText="All statuses"
        mixedValuesText="Statuses: Mixed Values"
        oneSelectedText="Status: "
        loading={statusOptionsLoading}
      />
      {showViewToggle && (
        <EnrollmentTabs
          className="descriptor-view-toggle"
          options={[
            { label: "Descriptor", value: "descriptor" },
            { label: "Codes", value: "codes", disabled: isCodesDisabled }
          ]}
          value={viewMode}
          onChange={onViewModeChange}
        />
      )}
    </Flex>
  )
}

export default DescriptorListFilters
